import { Component, Input, ViewEncapsulation } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-policy-service-shared',
  templateUrl: './policy-service-shared.component.html',
  styleUrl: './policy-service-shared.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PolicyServiceSharedComponent {
  @Input() loopNumber = 0
  @Input() customClass = ''
  public contentMenu = [
    { label: 'NAVIGATION.TERM_OF_SERVICE', link: 'term-of-use' },
    { label: 'NAVIGATION.PRIVACY_POLICY', link: 'privacy-statement' },
    { label: 'NAVIGATION.PRIVACY_NOTICE', link: 'privacy-notice' },
    { label: 'NAVIGATION.COOKIES_POLICY', link: 'cookies-policy' },
  ]
  constructor(public translate: TranslateService) {}
  loopArray() {
    return new Array(this.loopNumber)
  }
  getRouterLink(itemLink: string) {
    const lang = this.translate.currentLang
    return lang === 'th' ? ['/', itemLink] : ['/', 'en', itemLink]
  }
}
